/* eslint-disable no-underscore-dangle */
import { TRACKING_KEY, TRACKING_EVENT } from 'shared/constants';
import ultilitiesService from 'shared/util/ultilitiesService';

export const trackDropOff = (tracking, dropOff) => {
  const stopFlow = window.location.pathname.split('/')[1];
  const value = ultilitiesService.stringBuilder({
    stopFlow,
    stopStep: dropOff.stopStep,
    stopThread: dropOff.stopThread,
  });
  if (value && value !== '') {
    const body = {
      event: TRACKING_EVENT.ACCESS_PAGE,
      key: TRACKING_KEY.DROP_OFF,
      value,
      index: true,
      complex: true,
    };
    tracking.trackEvent(body);
  }
};

// export const userTimeSpent = (tracking, timeSpent = 0, stopStep = '') => {
//   const stopFlow = window.location.pathname.split('/')[1];
//   let value = `stopFlow=${stopFlow};`;
//   if (stopStep !== '') {
//     value += `stopStep=${stopStep};`;
//   }
//   if (timeSpent) {
//     value += `$timeSpent=${timeSpent}`;
//   }
//   const body = {
//     event: TRACKING_EVENT.ACCESS_PAGE,
//     key: TRACKING_KEY.TIME_SPENT,
//     value,
//     index: true,
//     complex: true,
//   };
//   tracking.trackEvent(body);
// };

export const trackUniqueUser = (tracking, data) => {
  const body = {
    event: TRACKING_EVENT.ACCESS_PAGE,
    key: TRACKING_KEY.UNIQUE_USER,
    value: data._id,
    index: true,
    complex: false,
  };
  tracking.trackEvent(body);
};

export const trackReturnVisitor = (tracking, data) => {
  const body = {
    event: TRACKING_EVENT.ACCESS_PAGE,
    key: TRACKING_KEY.RETURN_VISITOR,
    value: data._id,
    index: true,
    complex: false,
  };
  tracking.trackEvent(body);
};

export const trackDevice = (tracking, device) => {
  const body = {
    event: TRACKING_EVENT.PAYLOAD,
    key: TRACKING_KEY.DEVICE,
    value: device,
    index: true,
    complex: false,
  };
  tracking.trackEvent(body);
};

export const trackBrowser = (tracking, browser) => {
  const body = {
    event: TRACKING_EVENT.PAYLOAD,
    key: TRACKING_KEY.BROWSER,
    value: browser,
    index: true,
    complex: false,
  };
  tracking.trackEvent(body);
};

export const trackCountry = (tracking, res) => {
  const body = {
    event: TRACKING_EVENT.PAYLOAD,
    key: TRACKING_KEY.COUNTRY,
    value: `country=${res.country_name};continent=${res.continent_name}`,
    index: true,
    complex: true,
  };
  tracking.trackEvent(body);
};

export const trackPWAInstalled = (tracking, os) => {
  const body = {
    event: TRACKING_EVENT.PAYLOAD,
    key: TRACKING_KEY.PWA_INSTALLED,
    value: os,
    index: true,
    complex: false,
  };
  tracking.trackEvent(body);
};
